import { useStore as useStore$1, connect, useDispatch, Provider } from 'react-redux';
export { connect, useDispatch, useSelector } from 'react-redux';
import { createStore, applyMiddleware, combineReducers } from 'redux';
export { combineReducers } from 'redux';
import { PersistGate } from 'redux-persist/integration/react';
import * as actions from 'ts-action';
export { actions };
import { useLocalStorage, parseHtml, DistanceUnit } from '@grandvisionhq/utils';
export { DistanceUnit } from '@grandvisionhq/utils';
import * as React from 'react';
import React__default, { useContext } from 'react';
import { composeWithDevTools } from 'redux-devtools-extension';
import { composeWithDevTools as composeWithDevTools$1 } from 'redux-devtools-extension/logOnly';
import { persistStore, persistReducer as persistReducer$1 } from 'redux-persist';
import sessionStorage from 'redux-persist/lib/storage/session';
export { default as sessionStorage } from 'redux-persist/lib/storage/session';
import createSagaMiddleware, { END } from 'redux-saga';
export { default as localStorage } from 'redux-persist/lib/storage';
import { format } from 'date-fns';
import { createSelector } from 'reselect';

var g = typeof window === 'undefined' ? global : window;
function singletonMap(name) {
    var key = "__gv_singleton_maps-" + name;
    if (key in g) {
        return g[key];
    }
    return (g[key] = {});
}

var sagasMap = singletonMap('sagas');
var listener$1;
var SagaRegistry = {
    register: function (name, saga) {
        if (name in sagasMap) {
            console.warn("Saga with name '" + name + "' is already registered");
            return;
        }
        sagasMap[name] = saga;
        if (listener$1) {
            listener$1(saga);
        }
    },
    set listener(l) {
        listener$1 = l;
    },
    get sagas() {
        return Object.values(sagasMap);
    },
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}

var reducersMap = singletonMap('reducers');
var listener;
var ReducersRegistry = {
    get reducers() {
        return __assign({}, reducersMap);
    },
    set listener(l) {
        listener = l;
    },
    register: function (name, reducer) {
        reducersMap[name] = reducer;
        if (listener) {
            listener(__assign({}, reducersMap));
        }
    },
};

var sagaMiddleware = createSagaMiddleware();
var bindMiddleware = function (middleware) {
    return applyMiddleware.apply(void 0, __spreadArray([], __read(middleware)));
};
var persistConfig = {
    key: 'grandvision_store',
    whitelist: ['checkout', 'cart'],
    storage: sessionStorage,
};
var getRootReducer = function (reducers, isServer) {
    var rootReducer = combineReducers(__assign({}, reducers));
    if (isServer) {
        return rootReducer;
    }
    return persistReducer$1(persistConfig, rootReducer);
};
var initStore = function (initialState, _a) {
    if (initialState === void 0) { initialState = {}; }
    var isServer = _a.isServer;
    var rootReducer = getRootReducer(ReducersRegistry.reducers, isServer);
    var devToolsOptions = {
        serialize: true,
    };
    var devTools = process.env.NODE_ENV !== 'production'
        ? composeWithDevTools(devToolsOptions)
        : composeWithDevTools$1(devToolsOptions);
    var plainStore = createStore(rootReducer, initialState, devTools(bindMiddleware([sagaMiddleware])));
    // Add the redux persistor to the store
    var persistor = persistStore(plainStore);
    var store;
    if (!isServer) {
        store = Object.assign(plainStore, {
            persistor: persistor,
            // Make sure we run the sagas that have been registered before the store is initialized
            runningSagas: SagaRegistry.sagas.map(sagaMiddleware.run),
            runSaga: sagaMiddleware.run,
            close: function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            store.dispatch(END);
                            return [4 /*yield*/, Promise.all(store.runningSagas.map(function (t) { return t.toPromise(); }))];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); },
        });
    }
    else {
        store = Object.assign(plainStore, {
            persistor: persistor,
            runningSagas: [],
            close: function () { return Promise.resolve(); },
        });
        SagaRegistry.listener = function (sagas) {
            store.runningSagas.push(sagaMiddleware.run(sagas));
        };
    }
    ReducersRegistry.listener = function (reducers) {
        store.replaceReducer(getRootReducer(reducers, isServer));
    };
    return store;
};
function useStore() {
    return useStore$1();
}

var useSaga = function (saga, options, deps) {
    if (deps === void 0) { deps = []; }
    var store = useStore();
    var _a = __read(React.useState(null), 2), task = _a[0], setTask = _a[1];
    React.useDebugValue(task, function (t) { return t && { isRunning: t.isRunning(), error: t.error(), result: t.result() }; });
    React.useEffect(function () {
        var runningSaga = store.runSaga(saga);
        setTask(runningSaga);
        if (options === null || options === void 0 ? void 0 : options.onStart) {
            options === null || options === void 0 ? void 0 : options.onStart(runningSaga);
        }
        return function () {
            runningSaga.cancel();
        };
        // options.onStart is left out on purpose
        // putting in would cause infinite loops
    }, __spreadArray([store, saga], __read(deps)));
    return task;
};

var DEFAULT_LIMIT = 20;
/**
 * Creates a history array in the local storage with some helpers attached.
 *
 * @param key - used as key in the local storage
 * @param limit - limit of items stored in the history array
 *
 * @example usage
 *  import { useViewHistory } from '@grandvisionhq/state'
 *  export const useProductViewHistory = useViewHistory.bind(null, ViewHistoryKey.Products, 30)
 */
function useViewHistory(key, limit) {
    if (limit === void 0) { limit = DEFAULT_LIMIT; }
    var _a = __read(useLocalStorage(key, undefined), 2), history = _a[0], setHistory = _a[1];
    /**
     * Checks if an id exists in the current history
     */
    var has = React.useCallback(function (id) { var _a; return Boolean(history && ((_a = history.find(function (i) { return i === id; })) === null || _a === void 0 ? void 0 : _a.length)); }, [history]);
    /**
     * Adds one ID to the history array.
     * Duplicated IDs are not allowed.
     * New items are always added at the start of the history.
     * If the limit is exceeded, the last item(s) of the array are cut off.
     */
    var add = React.useCallback(function (id) {
        setHistory(function (state) {
            var _a;
            if (state === void 0) { state = []; }
            var hasId = Boolean((_a = state.find(function (i) { return i === id; })) === null || _a === void 0 ? void 0 : _a.length);
            var filtered = hasId ? __spreadArray([], __read(state.filter(function (i) { return i !== id; }))) : __spreadArray([], __read(state));
            return __spreadArray([id], __read(filtered)).slice(0, limit);
        });
    }, [limit]);
    /**
     * Removes one or more items from the history
     */
    var remove = React.useCallback(function (ids) {
        setHistory(function (state) {
            if (state === void 0) { state = []; }
            var filters = Array.isArray(ids) ? ids : [ids];
            return filters.reduce(function (result, next) { return __spreadArray([], __read(result.filter(function (i) { return i !== next; }))); }, __spreadArray([], __read(state)));
        });
    }, []);
    /**
     * Clears the entire history array by restoring the initial value
     */
    var clear = React.useCallback(function () {
        setHistory([]);
    }, []);
    return { history: history, has: has, add: add, remove: remove, clear: clear };
}

var persistReducer = function (config, reducer) {
    if (typeof window !== 'undefined' && window.document) {
        return persistReducer$1(config, reducer);
    }
    return reducer;
};

var INIT = 'api-config/INIT';
var init = function (payload) { return ({
    type: INIT,
    payload: payload,
}); };

function reducer$3 (state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case INIT:
            return __assign(__assign({}, state), action.payload);
        default:
            return state;
    }
}

var getApiConfig = function (state) {
    return state.apiConfig;
};

var selectors$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getApiConfig: getApiConfig
});

var createApiConfig = function (config) { return ({
    apiUrl: config.apiUrl,
    cartsUrl: config.cartsUrl || config.apiUrl + "/carts",
    locationsUrl: config.locationsUrl || config.apiUrl + "/locations",
    ordersUrl: config.ordersUrl || config.apiUrl + "/orders",
    paymentsUrl: config.paymentsUrl || config.apiUrl + "/payments",
    productsUrl: config.productsUrl || config.apiUrl + "/products",
    storesUrl: config.storesUrl || config.apiUrl + "/stores",
    subscriptionsUrl: config.subscriptionsUrl || config.apiUrl + "/subscriptions",
}); };

var ApiConfigContext = React.createContext(null);
function assertApiConfig(apiConfig) {
    if (apiConfig === null || apiConfig === undefined) {
        throw new Error('Missing API config provider. You have to wrap the application with the ApiConfigProvider component from the @grandvisionhq/state package.');
    }
}
var ApiConfigProvider = function (props) {
    React.useEffect(function () {
        props.init(createApiConfig(props.apiConfig));
    }, [JSON.stringify(props.apiConfig)]);
    return (React.createElement(ApiConfigContext.Provider, { value: createApiConfig(props.apiConfig) }, props.children));
};
function withApiConfig(Component) {
    var wrappedName = Component.displayName || Component.name || 'Component';
    var WithApiConfig = function (props) { return (React.createElement(ApiConfigContext.Consumer, null, function (apiConfig) {
        assertApiConfig(apiConfig);
        return React.createElement(Component, __assign({}, props, { apiConfig: apiConfig }));
    })); };
    WithApiConfig.displayName = "WithApiConfig(" + wrappedName + ")";
    return WithApiConfig;
}
function useApiConfig() {
    var context = React.useContext(ApiConfigContext);
    if (context === null) {
        throw new Error('Missing API config provider. You have to wrap the application with the ApiConfigProvider component from the @grandvisionhq/state package.');
    }
    return context;
}
var mapDispatchToProps = {
    init: init,
};
var ApiConfig = connect(null, mapDispatchToProps)(ApiConfigProvider);

ReducersRegistry.register('apiConfig', reducer$3);

var SET_FEATURE_TOGGLES = 'feature-toggles/SET';
var setFeatureToggles = function (payload) { return ({
    type: SET_FEATURE_TOGGLES,
    payload: payload,
}); };

function reducer$2 (state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case SET_FEATURE_TOGGLES:
            return __assign(__assign({}, state), action.payload);
        default:
            return state;
    }
}

var FeatureToggleContext = React__default.createContext({});
var useFeatureToggles = function () { return React__default.useContext(FeatureToggleContext); };
function withFeatureToggles(Component) {
    var wrappedName = Component.displayName || Component.name || 'Component';
    var WithFeatureToggles = function (props) { return (React__default.createElement(FeatureToggleContext.Consumer, null, function (context) { return React__default.createElement(Component, __assign({}, props, context)); })); };
    WithFeatureToggles.displayName = "WithFeatureToggles(" + wrappedName + ")";
    return WithFeatureToggles;
}
var FeatureToggleProvider = function (_a) {
    var children = _a.children, _b = _a.enabledFeatures, enabledFeatures = _b === void 0 ? [] : _b, _c = _a.enabledFeatureConfigs, enabledFeatureConfigs = _c === void 0 ? {} : _c;
    var dispatch = useDispatch();
    var stringifiedFeatureToggles = JSON.stringify(enabledFeatures);
    var stringifiedFeatureConfigs = JSON.stringify(enabledFeatureConfigs);
    var value = React__default.useMemo(function () {
        var _a;
        var isFeatureEnabled = function (feature) {
            return enabledFeatures.includes(feature.toUpperCase());
        };
        return {
            isAABEnabled: isFeatureEnabled('AAB'),
            isABTestingEnabled: isFeatureEnabled('ABTESTING'),
            isAddressBookEnabled: isFeatureEnabled('ADDRESSBOOK'),
            isAppointmentBookingUrlWithPostalCode: isFeatureEnabled('APPOINTMENT_BOOKING_URL_WITH_POSTAL_CODE'),
            isAvailabilityByStoreCodeEnabled: isFeatureEnabled('AVAILABILITY_BY_STORE_CODE'),
            isBynderImagesEnabled: isFeatureEnabled('BYNDER_IMAGES'),
            isCartV2Enabled: isFeatureEnabled('CART_V2'),
            isContactLensEnabled: isFeatureEnabled('CONTACTLENS'),
            isContactLensStockEnabled: isFeatureEnabled('CONTACTLENS_STOCK'),
            isCrossSellEnabled: isFeatureEnabled('CROSS_SELL'),
            isDownloadQuotationEnabled: isFeatureEnabled('DOWNLOAD_QUOTATION'),
            isGpsStoresEnabled: isFeatureEnabled('GPS_STORES'),
            isLegacyOrderSupplierEanEnabled: isFeatureEnabled('LEGACY_ORDER_SUPPLIER_EAN'),
            isMultiCountryLocationsEnabled: isFeatureEnabled('MULTI_COUNTRY_LOCATIONS'),
            isMultilingualEnabled: isFeatureEnabled('MULTILINGUAL'),
            isMyAccountEnabled: isFeatureEnabled('MYACCOUNT'),
            isPreferredContactMethodEnabled: isFeatureEnabled('PREFERRED_CONTACT_METHOD'),
            isStoreDetailAvailableAppointmentTimeSlotEnabled: isFeatureEnabled('STORE_DETAIL_AVAILABLE_APPOINTMENT_TIME_SLOTS'),
            isPrescriptionFileEnabled: isFeatureEnabled('PRESCRIPTION_FILE'),
            isPrescriptionGlassesConfiguratorValidationStepEnabled: isFeatureEnabled('PRESCRIPTION_GLASSES_CONFIGURATOR_VALIDATION_STEP'),
            isPrescriptionGlassesEnabled: isFeatureEnabled('PRESCRIPTION_GLASSES'),
            isPrescriptionGlassesReorderEnabled: isFeatureEnabled('PRESCRIPTION_GLASSES_REORDER'),
            isVEPrescriptionsEnabled: isFeatureEnabled('VE_PRESCRIPTIONS'),
            isInlinePrescriptionsEnabled: isFeatureEnabled('INLINE_PRESCRIPTIONS'),
            isReviewsEnabled: isFeatureEnabled('REVIEWS'),
            isStoreSearchEmailEnabled: isFeatureEnabled('STORE_SEARCH_SHOW_EMAIL'),
            isStoreSearchPhoneEnabled: isFeatureEnabled('STORE_SEARCH_SHOW_PHONE'),
            isStoreDetailsEmailEnabled: isFeatureEnabled('STORE_DETAILS_SHOW_EMAIL'),
            isStoreDetailsPhoneEnabled: isFeatureEnabled('STORE_DETAILS_SHOW_PHONE'),
            isStorePickupV2: isFeatureEnabled('STORE_PICKUP_V2'),
            isStorePickupEmailEnabled: isFeatureEnabled('STORE_PICKUP_SHOW_EMAIL'),
            isStorePickupPhoneEnabled: isFeatureEnabled('STORE_PICKUP_SHOW_PHONE'),
            isStoreSearchEnabled: isFeatureEnabled('STORE_SEARCH'),
            isStoresPlacePredictionsEnabled: isFeatureEnabled('STORES_PLACE_PREDICTIONS'),
            isSubscriptionHasOneAddressEnabled: isFeatureEnabled('SUBSCRIPTION_HAS_ONE_ADDRESS'),
            isSubscriptionsV2Enabled: isFeatureEnabled('SUBSCRIPTIONS_V2'),
            isSubscriptionUpdateAddressEnabled: isFeatureEnabled('SUBSCRIPTION_UPDATE_ADDRESS'),
            isDeliveryFullDateEnabled: isFeatureEnabled('DELIVERY_FULL_DATE'),
            isVtoEnabled: isFeatureEnabled('VTO'),
            featureConfigs: {
                prescriptionTypesOrder: (_a = enabledFeatureConfigs.PRESCRIPTION_TYPES_ORDER) === null || _a === void 0 ? void 0 : _a.split(','),
                maxSearchStoresResults: enabledFeatureConfigs.MAX_SEARCH_STORES_RESULTS !== undefined
                    ? parseInt(enabledFeatureConfigs.MAX_SEARCH_STORES_RESULTS, 10)
                    : undefined,
                appointmentBookingUrlPaddedLength: enabledFeatureConfigs.APPOINTMENT_BOOKING_URL_PADDED_LENGTH !== undefined
                    ? parseInt(enabledFeatureConfigs.APPOINTMENT_BOOKING_URL_PADDED_LENGTH, 10)
                    : undefined,
            },
        };
        // enabledFeatureConfigs.PRESCRIPTION_TYPES_ORDER is checked in stringified feature configs
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stringifiedFeatureToggles, stringifiedFeatureConfigs]);
    React__default.useEffect(function () {
        // Init/update feature toggle settings to our redux state
        dispatch(setFeatureToggles(value));
    }, [dispatch, value]);
    return React__default.createElement(FeatureToggleContext.Provider, { value: value }, children);
};

var getFeatureToggles = function (state) {
    return state.featureToggles;
};

var selectors$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getFeatureToggles: getFeatureToggles
});

ReducersRegistry.register('featureToggles', reducer$2);

var Locales;
(function (Locales) {
    Locales["en-IO"] = "en-IO";
    Locales["ca-ES"] = "ca-ES";
    Locales["da-DK"] = "da-DK";
    Locales["en-GB"] = "en-GB";
    Locales["es-ES"] = "es-ES";
    Locales["fr-BE"] = "fr-BE";
    Locales["it-IT"] = "it-IT";
    Locales["nl-BE"] = "nl-BE";
    Locales["nl-NL"] = "nl-NL";
    Locales["pt-PT"] = "pt-PT";
    Locales["sv-SE"] = "sv-SE";
    Locales["en-IE"] = "en-IE";
    Locales["fr-FR"] = "fr-FR";
})(Locales || (Locales = {}));
var Countries;
(function (Countries) {
    Countries["BE"] = "BE";
    Countries["DK"] = "DK";
    Countries["ES"] = "ES";
    Countries["GB"] = "GB";
    Countries["IO"] = "IO";
    Countries["IT"] = "IT";
    Countries["NL"] = "NL";
    Countries["PT"] = "PT";
    Countries["SE"] = "SE";
    Countries["IE"] = "IE";
    Countries["FR"] = "FR";
})(Countries || (Countries = {}));
var Currencies;
(function (Currencies) {
    Currencies["EUR"] = "EUR";
    Currencies["GBP"] = "GBP";
    Currencies["USD"] = "USD";
    Currencies["SEK"] = "SEK";
    Currencies["DKK"] = "DKK";
})(Currencies || (Currencies = {}));
var IntlContext = React__default.createContext({});
var useIntl = function () { return useContext(IntlContext); };
function withIntl(Component) {
    var wrappedName = Component.displayName || Component.name || 'Component';
    var WithIntl = function (props) { return (React__default.createElement(IntlContext.Consumer, null, function (context) { return React__default.createElement(Component, __assign({}, props, { intl: context })); })); };
    WithIntl.displayName = "WithIntl(" + wrappedName + ")";
    return WithIntl;
}

var SET_CONFIG = 'intl/SET_CONFIG';
var setConfig = function (payload) { return ({
    type: SET_CONFIG,
    payload: payload,
}); };

/**
 * Mapping to dynamically import the date-fns Locale object for your locale.
 * You can extend this map if you need a locale that's currently not in there if it's supported by date-fns.
 * https://date-fns.org/v2.0.0-beta.2/docs/I18n#supported-languages
 */
var dateFnsLocaleMap = {
    en: function () { return import('date-fns/locale/en-GB'); },
    'en-GB': function () { return import('date-fns/locale/en-GB'); },
    'en-US': function () { return import('date-fns/locale/en-US'); },
    it: function () { return import('date-fns/locale/it'); },
    nl: function () { return import('date-fns/locale/nl'); },
    pt: function () { return import('date-fns/locale/pt'); },
    sv: function () { return import('date-fns/locale/sv'); },
    da: function () { return import('date-fns/locale/da'); },
    fr: function () { return import('date-fns/locale/fr'); },
    es: function () { return import('date-fns/locale/es'); },
    ca: function () { return import('date-fns/locale/ca'); },
};
/**
 * Gets the dynamic import for the passed locale.
 * Use this function to get your locale import, don't expose the map directly.
 *
 * @example
 * const dateFnsLocaleModule = getDateFnsLocaleModule('it-IT')
 * const { default: dateFnsLocale } = await dateFnsLocaleModule()
 */
function getDateFnsLocaleModule(locale) {
    if (dateFnsLocaleMap[locale]) {
        return dateFnsLocaleMap[locale]();
    }
    // If we can't find an obj for the more specific locale (en-GB),
    // Try to find a less specific one for the language code only (en).
    var language = locale.substr(0, 2);
    if (dateFnsLocaleMap[language]) {
        return dateFnsLocaleMap[language]();
    }
    return undefined;
}

var handleFormatDate = function (dateFormats, value, dateFormatKey, options) {
    return format(value, dateFormats[dateFormatKey], options);
};
var handleLongDate = function (dateFormat, date, options) { return handleFormatDate(dateFormat, date, 'long', options); };
var handleMidsizeDate = function (dateFormat, date, options) { return handleFormatDate(dateFormat, date, 'midsize', options); };
var handleShortDate = function (dateFormat, date, options) { return handleFormatDate(dateFormat, date, 'short', options); };
var handleFormatTime = function (timeFormats, value, timeFormatKey, options) {
    return format(value, timeFormats[timeFormatKey || 'default'], options);
};

/**
 * Merges labels as received from the call to Bloomreach into a flat 1 level deep object,
 * and prefixes each label key with the key of the parent object (e.g. carts or stores)
 */
var mergeLabels = function (labels) {
    return Object.keys(labels).reduce(function (merged, key) { return (__assign(__assign({}, merged), Object.entries(labels[key]).reduce(function (innerLabels, _a) {
        var _b;
        var _c = __read(_a, 2), labelKey = _c[0], label = _c[1];
        return (__assign(__assign({}, innerLabels), (_b = {}, _b[key + "." + labelKey] = label, _b)));
    }, {}))); }, {});
};
var hasLabel = function (labels, key) { return !!labels[key]; };
var isDebugEnabled = (function () {
    try {
        return !!localStorage.getItem('gv:debug:intl');
    }
    catch (error) {
        return false;
    }
})();
var getLabel = function (labels, key, optionsConfig) {
    if (optionsConfig === void 0) { optionsConfig = {}; }
    var defaultValue = optionsConfig.defaultValue, _a = optionsConfig.hideLabelKey, hideLabelKey = _a === void 0 ? false : _a;
    if (isDebugEnabled) {
        return "[" + key + "]";
    }
    return labels[key] || defaultValue || (hideLabelKey ? '' : "[" + key + "]");
};
var getFormattedLabel = function (labels, key, optionsConfig) {
    if (optionsConfig === void 0) { optionsConfig = {}; }
    var parseLinkEnabled = optionsConfig.parseLink, parseHTML = optionsConfig.parseHTML, labelData = optionsConfig.labelData, openLinksInNewTab = optionsConfig.openLinksInNewTab, getLabelOptions = __rest(optionsConfig, ["parseLink", "parseHTML", "labelData", "openLinksInNewTab"]);
    var label = getLabel(labels, key, getLabelOptions);
    if (isDebugEnabled) {
        return label;
    }
    if (labelData) {
        label = replaceVars(label, labelData);
    }
    if (parseLinkEnabled) {
        label = parseLink(label, openLinksInNewTab);
    }
    /*
      by default parses if parseLinkEnabled,
      unless parseHTML explicitly set to false
    */
    if (parseHTML || (parseLinkEnabled && parseHTML !== false)) {
        label = parseHtml(label);
    }
    return label;
};
var replaceVars = function (label, data) {
    Object.keys(data).forEach(function (key) {
        label = label.replace("{" + key + "}", data[key].toString());
    });
    return label;
};
// Parses MarkDown style links to HTML string
// [I'm an inline-style link with title](https://www.google.com "Google's Homepage")
var parseLink = function (label, openInNewTab) {
    if (openInNewTab === void 0) { openInNewTab = false; }
    var regex = /[\[]{1}([^\]\[]+)[\]]{1}[(]{1}([^()"]+)("(.+)")?[)]{1}/g;
    return label.replace(regex, openInNewTab
        ? '<a href="$2" title="$4" target="_blank" rel="noopener">$1</a>'
        : '<a href="$2" title="$4">$1</a>');
};

var supportedLocales = Object.keys(Locales);
var supportedCurrencies = Object.keys(Currencies);
var supportedDistanceUnits = Object.keys(DistanceUnit);
var settingsDefaults = {
    distanceUnit: DistanceUnit.km,
    dateFormat: {
        long: 'EEEE do MMMM, yyyy',
        midsize: 'dd MMMM yyyy',
        short: 'dd/MM/yyyy', // 06/03/2019
    },
    timeFormat: {
        default: 'H:mm', // 15:30 (24hr time, no preceding zero for the hour)
    },
};
var mergeSettings = function (settings) { return (__assign(__assign({}, settingsDefaults), settings)); };
var IntlProvider = function (_a) {
    var settings = _a.settings, labels = _a.labels, children = _a.children;
    var _b = mergeSettings(settings), country = _b.country, currency = _b.currency, locale = _b.locale, distanceUnit = _b.distanceUnit, dateFormat = _b.dateFormat, timeFormat = _b.timeFormat;
    var dispatch = useDispatch();
    var _c = __read(React.useState(), 2), dateFnsLocale = _c[0], setDateFnsLocale = _c[1];
    var value = React.useMemo(function () { return ({
        country: country,
        currency: currency,
        distanceUnit: distanceUnit,
        locale: locale,
        dateFormat: dateFormat,
        timeFormat: timeFormat,
        dateFnsLocale: dateFnsLocale,
        dateTime: makeDateTimeObject(dateFnsLocale, dateFormat, timeFormat),
        getLabel: function (key, options) { return getLabel(labels, key, options); },
        getFormattedLabel: function (key, options) { return getFormattedLabel(labels, key, options); },
        hasLabel: function (key) { return hasLabel(labels, key); },
    }); }, [country, currency, dateFnsLocale, dateFormat, distanceUnit, labels, locale, timeFormat]);
    React.useEffect(function () {
        // Log some warnings if invalid settings were passed
        validateSettings({ country: country, currency: currency, locale: locale, distanceUnit: distanceUnit });
        // Init/update intl settings to our redux state
        dispatch(setConfig({
            country: country,
            currency: currency,
            locale: locale,
            distanceUnit: distanceUnit,
            dateFormat: dateFormat,
            timeFormat: timeFormat,
        }));
        // Lazy load the date-fns locale module for the locale that was passed
        var dateFnsLocaleModule = getDateFnsLocaleModule(locale);
        if (dateFnsLocaleModule) {
            dateFnsLocaleModule.then(function (module) {
                if (module && 'default' in module) {
                    setDateFnsLocale(module.default);
                }
            });
        }
        else {
            console.warn("Could not find a date-fns locale obj for locale: " + locale);
        }
    }, [country, currency, dateFormat, dispatch, distanceUnit, locale, timeFormat]);
    return React.createElement(IntlContext.Provider, { value: value }, children);
};
function makeDateTimeObject(locale, dateFormat, timeFormat) {
    var options = !!locale ? { locale: locale } : undefined;
    return {
        formatDate: function (dateTime, key) {
            return handleFormatDate(dateFormat, dateTime, key, options);
        },
        formatLongDate: function (dateTime) {
            return handleLongDate(dateFormat, dateTime, options);
        },
        formatMidsizeDate: function (dateTime) {
            return handleMidsizeDate(dateFormat, dateTime, options);
        },
        formatShortDate: function (dateTime) {
            return handleShortDate(dateFormat, dateTime, options);
        },
        formatTime: function (dateTime, key) {
            return handleFormatTime(timeFormat, dateTime, key, options);
        },
    };
}
function validateSettings(_a) {
    var country = _a.country, currency = _a.currency, locale = _a.locale, distanceUnit = _a.distanceUnit;
    if (!(country in Countries)) {
        console.warn("Invalid country \"" + country + "\" set on IntlProvider. Use 2 uppercase characters like \"GB\"");
    }
    if (!(locale in Locales)) {
        console.warn("Unsupported locale \"" + locale + "\" set on IntlProvider. Supported locales are: " + supportedLocales.join(', '));
    }
    if (!supportedCurrencies.includes(currency)) {
        console.warn("Unsupported or invalid currency \"" + currency + "\" set on IntlProvider. Supported currencies are: " + supportedCurrencies.join(', '));
    }
    if (!distanceUnit || !supportedDistanceUnits.includes(distanceUnit)) {
        console.warn("Unsupported or invalid distance unit \"" + distanceUnit + "\" set on IntlProvider. Supported distance units are: " + supportedDistanceUnits.join(', '));
    }
}

function reducer$1 (state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case SET_CONFIG:
            return __assign(__assign({}, state), action.payload);
        default:
            return state;
    }
}

var getIntl = function (state) { return state.intl; };
var getCurrency = createSelector(getIntl, function (intl) { var _a; return (_a = intl === null || intl === void 0 ? void 0 : intl.currency) !== null && _a !== void 0 ? _a : undefined; });
var getCountry = createSelector(getIntl, function (intl) { var _a; return (_a = intl === null || intl === void 0 ? void 0 : intl.country) !== null && _a !== void 0 ? _a : undefined; });
var getLocale = createSelector(getIntl, function (intl) { var _a; return (_a = intl === null || intl === void 0 ? void 0 : intl.locale) !== null && _a !== void 0 ? _a : undefined; });
var getDistanceUnit = createSelector(getIntl, function (intl) { var _a; return (_a = intl === null || intl === void 0 ? void 0 : intl.distanceUnit) !== null && _a !== void 0 ? _a : undefined; });

var selectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getIntl: getIntl,
  getCurrency: getCurrency,
  getCountry: getCountry,
  getLocale: getLocale,
  getDistanceUnit: getDistanceUnit
});

ReducersRegistry.register('intl', reducer$1);

/**
 * Statuses
 */
var UNAVAILABLE = 'unavailable';
var IDLE = 'idle';
var UNINIT = 'uninitialized';
var SUCCESS = 'success';
var LOADING = 'loading';
var FAILED = 'failed';
var WARNING = 'warning';
/**
 * State creators
 */
var unavailableState = function () { return ({ status: UNAVAILABLE }); };
var idleState = function () { return ({ status: IDLE }); };
var uninitState = function () { return ({ status: UNINIT }); };
var loadingState = function () { return ({ status: LOADING }); };
var successState = function (result) { return ({
    status: SUCCESS,
    result: result,
}); };
var warningState = function (state, error) {
    return __assign(__assign({}, state), { status: WARNING, error: error });
};
var failedState = function (error) { return ({
    status: FAILED,
    error: error,
}); };
/**
 * State guards
 */
var statusIdle = function (state) {
    return state.status === IDLE;
};
var statusUnavailable = function (state) { return state.status === UNAVAILABLE; };
var statusUninit = function (state) { return state.status === UNINIT; };
var statusLoading = function (state) { return state.status === LOADING; };
var statusSuccess = function (state) { return state.status === SUCCESS; };
var statusWarning = function (state) { return state.status === WARNING; };
var statusFailed = function (state) { return state.status === FAILED; };

var ViewHistoryKey;
(function (ViewHistoryKey) {
    ViewHistoryKey["Products"] = "view_history.products";
})(ViewHistoryKey || (ViewHistoryKey = {}));

// Re-export within redux namespace
var ReduxProvider = Provider;
var ReduxPersistGate = PersistGate;
var reducer = actions.reducer;

export { ApiConfigContext, ApiConfig as ApiConfigProvider, selectors$2 as ApiConfigSelectors, Countries, Currencies, DEFAULT_LIMIT, FAILED, FeatureToggleProvider, selectors$1 as FeatureToggleSelectors, IDLE, IntlContext, IntlProvider, selectors as IntlSelectors, LOADING, Locales, ReducersRegistry, ReduxPersistGate, ReduxProvider, SUCCESS, SagaRegistry, UNAVAILABLE, UNINIT, ViewHistoryKey, WARNING, assertApiConfig, failedState, idleState, initStore, loadingState, mergeLabels, persistConfig, persistReducer, reducer, statusFailed, statusIdle, statusLoading, statusSuccess, statusUnavailable, statusUninit, statusWarning, successState, unavailableState, uninitState, useApiConfig, useFeatureToggles, useIntl, useSaga, useStore, useViewHistory, warningState, withApiConfig, withFeatureToggles, withIntl };
//# sourceMappingURL=index.es.js.map
